import { useEffect, useRef, useState } from "react";

interface ScrollCounterProps {
  onScrollCounter: () => void;
}

export const ScrollCounter: React.FC<ScrollCounterProps> = ({
  onScrollCounter,
}) => {
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const triggerPosition = window.innerHeight / 2;
      if (window.scrollY > triggerPosition && !triggered) {
        setTriggered(true);
        onScrollCounter();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [onScrollCounter, triggered]);

  return null;
};
